export const SESSION_COOKIE = "session";
export const REDIRECT_COOKIE = "returnTo";
export const REDIRECT_COOKIE_DURATION_MS = 3600 * 1000;
